import { ReactNode } from 'react';

import { ActivityBuilderThemeContextProvider } from '../theme/activity-builder-theme';
import { ActivityBuilderPresentContextProvider } from './activity-builder-present.context';
import { ActivityAnswerPrintContextProvider } from '../print/answers/activity-answers-print.context';
import { TTSProvider } from '../tts/tts.context';
import { InvisiblePrintWrapper } from '../print/activity-builder-print-generator.style';
import {
  PRESENT_CONTEXT_MENU_CONTAINER,
  PRESENT_MENU_CONTAINER_ID,
  PRESENT_PRINT_CONTAINER,
} from './activity-builder-present.constants';
import { useGetInteractiveLessonParams } from '../activity-builder.hooks';

const ActivityPresentWrapper = ({
  children,
  classId,
}: {
  children: ReactNode;
  classId: number | null;
}) => {
  const { contentId, contentType } = useGetInteractiveLessonParams();
  return (
    <ActivityBuilderThemeContextProvider>
      <ActivityBuilderPresentContextProvider initialClassId={classId}>
        <TTSProvider>
          <ActivityAnswerPrintContextProvider
            contentId={contentId}
            contentType={contentType}
            classId={classId ?? 0}
          >
            <InvisiblePrintWrapper id={PRESENT_PRINT_CONTAINER} />
            <div id={PRESENT_MENU_CONTAINER_ID} />
            <div id={PRESENT_CONTEXT_MENU_CONTAINER} />
            {children}
          </ActivityAnswerPrintContextProvider>
        </TTSProvider>
      </ActivityBuilderPresentContextProvider>
    </ActivityBuilderThemeContextProvider>
  );
};

export default ActivityPresentWrapper;
